import * as React from 'react';
export default function myVehicle(WrappedComponent) {
    return function PP(props) {
        return React.createElement(WrappedComponent, { ...props, myVehicle: true });
    };
}
